import { format } from "date-fns";

/**
 * 📆 Formats the raw date received from the api to DD/MM/YYYY HH:mm:ss date string
 * @param dateString
 */
export function formatDateFromAPI(
  dateString: number,
  includeTime: boolean = false,
  includeTimezone: boolean = false
): string {
  return format(
    Number(dateString) * 1000,
    includeTime
      ? includeTimezone
        ? "dd/MM/yyyy HH:mm:ss z"
        : "dd/MM/yyyy HH:mm:ss"
      : "dd/MM/yyyy"
  );
}

/**
 * 📆 Converts seconds to minutes, hours or days
 * @param seconds
 */
export function formatSecondsToMinutesHoursOrDays(seconds: number): string {
  let minutes: number = Number(seconds) / 60;
  if (minutes < 60) {
    return Math.ceil(minutes) + "min";
  }

  let hours: number = minutes / 60;
  if (hours < 24) {
    return Math.round(hours) + "h";
  }

  let days = hours / 24;
  if (days < 31) {
    return Math.round(days) + "d";
  }

  let months = days / 30;
  if (months <= 12) {
    return Math.round(months) + "mo";
  }

  return (months / 12).toFixed(2) + "yr";
}

/**
 * 📆 Converts seconds to minutes, hours or days
 * @param seconds
 */
export function formatSecondsUpToDays(seconds: number): string {
  let minutes: number = (new Date().getTime() / 1000 - Number(seconds)) / 60;
  if (minutes < 60) {
    return Math.ceil(minutes) + "min";
  }

  let hours: number = minutes / 60;
  if (hours < 24) {
    return Math.floor(hours) + "h";
  }

  let days = hours / 24;
  return Math.floor(days) + "d";
}

/**
 * 📆 Converts seconds to years + months + days
 * @param seconds
 */
export function formatSecondsToExactTimeFromYearsToDays(seconds: number) {
  let y = Math.floor(seconds / 31536000);
  let mo = Math.floor((seconds % 31536000) / 2628000);
  let d = Math.floor(((seconds % 31536000) % 2628000) / 86400);

  let yDisplay = y > 0 ? y + "yr" : "";
  let moDisplay = mo > 0 ? mo + "mo" : "";
  let dDisplay = d > 0 ? d + "d" : "";
  return [yDisplay, moDisplay, dDisplay].join(" ");
}
